if (!customElements.get('wishlist-add')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();

      this.syncCountUnsubscribe = undefined;
      //costumer id and user type
      this.customerType = window.analyzify?.shopify_customer.type || 'visitor';
      this.customerId = this.customerType === 'member' ? window.analyzify?.shopify_customer.id : 'visitor';
      //product info
      this.productHandle = this.dataset.product;
      this.productName = this.dataset.productname;
      this.productId = this.dataset.productid;
      //page info
      this.path = window.location.pathname;
      this.pageInfo = document.body.className.replace('template-','');
      this.pageType = typeof this.pageInfo === 'string' && this.path.toLowerCase().includes('favoritter') ? 'wishlist' 
                    : typeof this.pageInfo === 'string' && this.pageInfo.toLowerCase().includes('index') ? 'home' : this.pageInfo;
      this.pageUrl = this.path
      // section info
      const swiper = this.closest('.swiper-carousel');
      const collectionGrid = this.closest('collection-page');
      if (swiper) {
        const header = swiper.parentElement.querySelector('.section__header .content__title.h2');
        this.section = header ? header.innerText : '';
      } else if (collectionGrid) {
        this.section = 'collection-grid';
      } else {
        this.section = this.dataset.section ? this.dataset.section : '';
      }

      if (this.productHandle 
          && this.customerType 
          && this.customerId 
          && this.productId 
          && this.productName 
          && this.pageInfo
          && this.pageType
          && this.pageUrl 
          && this.section !== undefined) this.bindEvents();

    }

    connectedCallback() {
      this.checkExist();

      requirejs(['pubsub'], () => {
        this.syncCountUnsubscribe = subscribeEvent(
          PUB_SUB_EVENTS.wishlistSync,
          ({ source, data }) => {
            this.checkExist();
          }
        );
      })
    }

    disconnectedCallback() {
      if (this.syncCountUnsubscribe) this.syncCountUnsubscribe();
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const hasInWishlist = this.classList.contains('is-active');

        if (hasInWishlist) {
          this.removeWishlist();
          this.classList.remove('is-active');
        } else {
          this.addWishlist();
          this.classList.add('is-active');
        }

        publishEvent(PUB_SUB_EVENTS.wishlistUpdate, {
          source: 'wishlist-add',
          data: {}
        });
      });
    }

    checkExist() {
      const wishlist = localStorage.getItem('wishlist');
      if (!wishlist) return;

      if (wishlist.includes(this.productHandle)) this.classList.add('is-active');
    }

    addWishlist() {
      const prevWishlist = localStorage.getItem('wishlist');
      let wishlistText = '';

      if (prevWishlist) {
        const isExist = prevWishlist.includes(this.productHandle);
        isExist ? '' : (wishlistText = prevWishlist + '||' + this.productHandle);
      } else wishlistText = this.productHandle;

      if (wishlistText) {
          localStorage.setItem('wishlist', wishlistText);
          window.dispatchEvent(new Event('wishlistUpdated'));
          this.createAndShowWishlistPopup();
      }

      window.dataLayer.push({
          event: 'wishlist-add',
          customer_id: this.customerId,
          product_id: this.productId,
          product_name: this.productName,
          page_type: this.pageType,
          page_path: this.pageUrl,
          section: this.section
      });
    }

    createAndShowWishlistPopup() {
      const container = document.getElementById('wishlist-popup-container');
      if (!container) return;

      const popup = document.createElement('div');
      popup.className = 'wishlist-popup';
      popup.id = `popup-${Date.now()}`;

      // we create popup dynamically
      popup.innerHTML = `
        <button class="wishlist-popup-close">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 6L18 18" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="wishlist-popup-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="popup-body">
          <p>Produktet er lagt til ønskelisten</p>
          <a href="/pages/favoritter">Gå til ønskelisten</a>
        </div>
      `;

      container.appendChild(popup);

      const removeCurrentPopup = () => {
        popup.style.animation = 'fadeOut 0.3s ease-in forwards';
        popup.addEventListener('animationend', () => {
          popup.remove();
        });
      };
      
      popup.querySelector('.wishlist-popup-close').addEventListener('click', removeCurrentPopup);

      setTimeout(removeCurrentPopup, 5000);
    }

    removeWishlist() {
      const wishList = localStorage.getItem('wishlist');
      if (!wishList) return;

      let removedWishlist = '';

      wishList.split('||').forEach((wishlistItem) => {
        if (this.productHandle != wishlistItem) {
          removedWishlist == ''
            ? (removedWishlist += wishlistItem)
            : (removedWishlist += `||${wishlistItem}`);
        }
      });

      localStorage.setItem('wishlist', removedWishlist);
      // also remove quantity info
      const quantities = localStorage.getItem('wishlist_quantities');
      if (quantities) {
        let quantitiesObj = JSON.parse(quantities);
        delete quantitiesObj[this.productHandle];
        localStorage.setItem('wishlist_quantities', JSON.stringify(quantitiesObj));
      }
      window.dataLayer.push({
          event: 'wishlist-remove',
          customer_id: this.customerId,
          product_id: this.productId,
          product_name: this.productName,
          page_type: this.pageType,
          page_path: this.pageUrl,
          section: this.section
      });
    }
  }

  customElements.define('wishlist-add', WishlistButton);
}
